import React from 'react';
import { Link } from 'react-router-dom';
import { Badge, Label } from '@therms/atalaya';
import './Versions.css';

export const Versions = (props) => {
  const procedureVersions =
    props.rpcScopeProcedure.versionsByScopeProcedure[props.params.scope][
      props.params.procedure
    ];

  const versionCheck = (version) => {
    if (version === props.params.version) {
      return <Badge variant="info" value={version} />;
    } else {
      return <Badge variant="neutral" value={version} />;
    }
  };

  if (procedureVersions.length <= 1) return null;

  return (
    <div className="versions">
      <Label>Versions</Label>{' '}
      {procedureVersions.map((version) => (
        <div className="version-list" key={version}>
          <Link
            to={`/docs/${props.params.scope}/${props.params.procedure}/${version}`}
          >
            {versionCheck(version)}
          </Link>
        </div>
      ))}
    </div>
  );
};
